
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUsers } from "../../services/Admin";

const initialState = {
    adminUserDetails: [],
    isLoading: false,
    error: null,
    filteredChips: [],
    count: 0,
};

export const getAdminUsersApi = createAsyncThunk("adminUser/getAdminUsersApi", async ({ filteredData, page, size }) => {
    try {

        const response = await getUsers(filteredData, page, size);
        return response;
    } catch (error) {
        throw error;
    }
});

const adminUserSlice = createSlice({
    name: "adminUser",
    initialState,
    reducers: {
        setInitAdminUserDetail: (state) => {
            state.adminUserDetails = [];
        },
        setFilteredChips: (state, action) => {
            state.filteredChips = action.payload;
        },
        clearFilteredChips: (state) => {
            state.filteredChips = [];
        },
        resetAdminUserState: (state) => {
            Object.assign(state, initialState);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getAdminUsersApi.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        });

        builder.addCase(getAdminUsersApi.fulfilled, (state, action) => {
            state.isLoading = false;
            const {data, count } = action?.payload;
            state.adminUserDetails = data;
            state.count = count;
        });

        builder.addCase(getAdminUsersApi.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error.message;
        });
    },
});

const { reducer } = adminUserSlice;
export const { setInitAdminUserDetail, setFilteredChips, clearFilteredChips, resetAdminUserState } = adminUserSlice.actions;
export default reducer;
